import React from "react";
import "./Projects.css";

// Sample data for projects/events
const upcomingEvent = {
  title: "2ND ANNUAL DECEMBER SPORTS TOURNAMENT",
  description:
    "We are closing the year with the tradition we began – a celebration of youth, talent, and community joy. BIGGER. BOLDER. AND BETTER.",
  image:
    "https://mapesafoundation.co.za/wp-content/uploads/2025/05/Mapesa-December-Tournament-2025-Poster.jpg",
};

const pastProjects = [
  {
    title: "ZONE 6 NETBALL & SOCCER WINTER TOURNAMENT",
    description:
      "A mid-year gathering of rising stars and community pride. This tournament is more than sports; it’s about unity, opportunity and youth development through play.",
  },
  {
    title: "MENTAL HEALTH SEMINAR",
    description:
      "A safe space for healing, learning, and un-learning. We are breaking the silence and championing conversations that matter, especially in disadvantaged communities.",
  },
  {
    title: "DONATION DRIVES",
    description:
      "Continuing our mission of meeting people where they are & delivering support where it’s most needed – from food parcels to school essentials.",
  },
];

export default function Projects() {
  return (
    <div className="container">
      <section className="programs" id="programs">
        <h2>Projects</h2>

        {/* Upcoming Event */}
        <div className="upcoming-event">
              <div className="upcoming-text">
              <h2>{upcomingEvent.title}</h2>
              </div>
          <div className="upcoming-columns">
            <div className="upcoming-text"> 
              <p>{upcomingEvent.description}</p>{" "}
              <div className="current-image-wrapper"></div>
            </div>
            <div className="update-image-wrapper">
              <div className="update-image"></div>
            </div>
          </div>
        </div>

        {/* Past Projects */}
        <div className="past-events">
          <h2>Past Projects 2025</h2>
          <div className="past-events-container">
            {pastProjects.map((project, index) => (
              <div className="event-card" key={index}>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
